import { render, staticRenderFns } from "./StartupEditFeatures.vue?vue&type=template&id=a40defce&scoped=true"
import script from "./StartupEditFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./StartupEditFeatures.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40defce",
  null
  
)

export default component.exports